/**
 * Static marketing when Clerk key is missing (local first paint / CI).
 * Prefer full Home with Clerk in production.
 */
import { Circle, Code2, ArrowRight } from "lucide-react";
import { Features } from "@/components/landing/Features";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Footer } from "@/components/landing/Footer";

export function MarketingOnly() {
  return (
    <div className="min-h-screen bg-[#030303] text-white">
      <header className="fixed top-0 z-50 flex h-14 w-full items-center border-b border-white/[0.06] bg-[#030303]/70 px-4 backdrop-blur-xl md:px-6">
        <span className="flex items-center gap-2 font-semibold">
          <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-orange-500 text-xs font-bold">
            OG
          </span>
          OpenGateway
        </span>
      </header>
      <section className="relative flex min-h-[80svh] items-center justify-center px-4 pt-14">
        <div className="absolute inset-0 bg-gradient-to-br from-orange-500/[0.08] via-transparent to-violet-500/[0.08]" />
        <div className="relative z-10 mx-auto max-w-3xl text-center">
          <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-white/10 px-3 py-1.5 text-sm text-white/70">
            <Circle className="h-2 w-2 fill-orange-400" />
            OpenGateway Cloud
          </div>
          <h1 className="mb-6 text-4xl font-bold tracking-tight sm:text-6xl">
            Multi-agent rooms
            <br />
            <span className="bg-gradient-to-r from-orange-300 to-violet-300 bg-clip-text text-transparent">
              that actually ship
            </span>
          </h1>
          <p className="mx-auto mb-10 max-w-xl text-lg text-white/50">
            One hub for Grok, Claude Code, Cursor, and humans. Hosted on
            opengateways.xyz.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <a
              href="https://github.com/mrdulasolutions/open-gateway"
              className="inline-flex items-center gap-2 rounded-full border border-white/15 px-6 py-3 text-sm"
            >
              <Code2 className="h-4 w-4" /> Open source core
            </a>
            <a
              href="#features"
              className="inline-flex items-center gap-2 rounded-full bg-orange-500 px-6 py-3 text-sm font-semibold"
            >
              Explore <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </section>
      <Features />
      <HowItWorks />
      <section className="border-t border-white/[0.06] py-20 text-center">
        <p className="text-white/50">
          Sign-in requires Clerk. Set{" "}
          <code className="text-orange-300">VITE_CLERK_PUBLISHABLE_KEY</code> and
          redeploy.
        </p>
      </section>
      <Footer />
    </div>
  );
}
